(function(){
	'use strict';
	angular
	.module('myApp')
	.filter('magicFilter', function() {
	  return function(input) {

	  };
	});
});
// this is here to allow gulp to minify
(function(){
	'use strict';
	angular
	.module('myApp')
	.filter('phoneFormat', function () {
		return function (phoneFormat) {
			if (!phoneFormat){
				return ''; 
			}
			
			var value = phoneFormat.toString().trim().replace(/^\+/, '');

			if (value.match(/[^0-9]/)) {
				return phoneFormat;
			}
			switch (value.length) {
				default:
					number = value;
			}
			if(number){
				if(number.length>3){
					number = number.slice(0, 3) + '.' + number.slice(3,6) + '.' + number.slice(6,10);
				}
			}
			return number;
		};
	})
});

//# sourceMappingURL=filters.js.map
